import { Injectable } from '@angular/core';
import { Logger, LoggerStrategies } from '~shared/modules/logger/models';
import { ServerLoggerStrategy } from '~shared/modules/logger/services/server-logger.strategy';
import { InstanaStrategy } from '~shared/modules/logger/services/instana.strategy';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggerService implements Logger{
  protected defaultLoggingStrategy: Logger;
  protected fallBackLoggingStrategy: Logger;
  public currentStrategy: Logger;
  FF_DEFAULT_LOGGER_STRATEGY = 'FF_DEFAULT_LOGGER_STRATEGY';
  FF_FALLBACK_LOGGER_STRATEGY = 'FF_FALLBACK_LOGGER_STRATEGY';

  private strategyMaps = {
    [LoggerStrategies.serverLogger]: this.serverLoggerStrategy,
    [LoggerStrategies.instanaLogger]: this.instanaStrategy
  };

  constructor(private serverLoggerStrategy: ServerLoggerStrategy,
              private instanaStrategy: InstanaStrategy,
              private activeFeatureToggleService: ActiveFeaturesConfigcatService
  ) {

    forkJoin<string, string>([
      this.activeFeatureToggleService.getFeatureValue(this.FF_DEFAULT_LOGGER_STRATEGY, LoggerStrategies.serverLogger),
      this.activeFeatureToggleService.getFeatureValue(this.FF_FALLBACK_LOGGER_STRATEGY, LoggerStrategies.serverLogger)
    ])
    .subscribe(([fallbackStrategy, defaultStrategy]) => {

      this.defaultLoggingStrategy = this.resolveStrategy(defaultStrategy);
      this.fallBackLoggingStrategy = this.resolveStrategy(fallbackStrategy);
      this.currentStrategy = this.resolveStrategy(defaultStrategy);
    });
  }


  debug(message, data,  strategy?): void {
    const strategyToUse = this.checkForCustomStrategy(strategy);
    this.emit(strategyToUse, 'debug', message, data);
  }

  error(error, message?, strategy?): void {
   const strategyToUse = this.checkForCustomStrategy(strategy);
   this.emit(strategyToUse, 'error', error, message);
  }

  info(message, data,  strategy?): void {
    const strategyToUse = this.checkForCustomStrategy(strategy);
    this.emit(strategyToUse, 'info', message, data);
  }

  warning(message, data,  strategy?): void {
    const strategyToUse = this.checkForCustomStrategy(strategy);
    this.emit(strategyToUse, 'warning', message, data);
  }

  private emit(strategy, mode, ...params) {
    try {
      strategy[mode](...params);
    }catch (error) {
      // failed to emit with selected strategy, using fallback
      this.fallBackLoggingStrategy.error(error, `Logger strategy failed to emit method ${mode}`);
      this.fallBackLoggingStrategy[mode](...params);
    }

  }

  changeStrategy(strategyName: keyof typeof LoggerStrategies) {
    this.currentStrategy = this.resolveStrategy(strategyName);
  }

  private checkForCustomStrategy(strategy) {
    if (strategy) {
      return this.resolveStrategy(strategy);
    }
    return this.currentStrategy;
  }

  private resolveStrategy(strategyName: string) {
    if (this.strategyMaps[strategyName]) {
      return this.strategyMaps[strategyName];
    }
    throw new Error(`Unknown logger strategy  ${strategyName}`);
  }

}
